import { SpareCarrier } from "@/pages/rollshop/models/SpareCarrier";
import { Chip, Tooltip } from "@mui/material";
import { ColDef, ColGroupDef, ICellRendererParams } from "ag-grid-enterprise";
import { useNavigate } from "react-router-dom";
import {
	actionRequiredCodes,
	ActionRequiredTag,
} from "../components/ActionRequiredTag";
import { CommentsColumn } from "../components/comment/CommentsColumn";

const CarrierChip = ({
	carrier,
}: {
	carrier: { status: string; name: string; id: number | null };
}) => {
	const status = [
		{ Code: "I", Name: "Installed", Color: "#004999" },
		{ Code: "S", Name: "Signed Off", Color: "#009460" },
		{ Code: "R", Name: "Ready", Color: "#ff9800" },
	];

	const backgroundColor = status.find((c) => c.Code === carrier.status)?.Color;
	const navigate = useNavigate();

	return (
		<Tooltip
			title={status.find((c) => c.Code === carrier.status)?.Name ?? ""}
			onClick={() => {
				navigate(`/carriers-assembly/${carrier.id}`);
			}}
		>
			<Chip
				style={{
					backgroundColor,
					color: carrier.status === "I" ? "white" : "black",
				}}
				label={carrier.name}
				size="small"
			/>
		</Tooltip>
	);
};

// In the future, the next section will have these chip
/* const CarrierCandidateChip = ({
  carrier,
}: {
  carrier: { status: string; name: string };
}) => {
  const colors = [
    { Code: "N", Name: "None", Color: "#00D188" },
    { Code: "S", Name: "Soft Change", Color: "#FAD215" },
    { Code: "F", Name: "Full Change", Color: "#F09EA2" },
  ];

  const backgroundColor = colors.find((c) => c.Code === carrier.status)?.Color;

  return (
    <Chip
      style={{ backgroundColor, color: "black" }}
      label={carrier.name}
      size="small"
    />
  );
}; */

export const useTableDataLeft = () => {
	const columnDefsLeft: (ColDef | ColGroupDef)[] = [
		{
			field: "StandName",
			headerName: "Stand",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "CarrierSpares",
			headerName: "Carriers - Spares",
			cellRenderer: (params: ICellRendererParams) => {
				const carriers = (params.data as SpareCarrier)?.SparesFormatted || [];

				return (
					<div style={{ display: "flex", gap: "4px", flexWrap: "wrap" }}>
						{carriers.length > 0 &&
							carriers.map(
								(
									spare: { status: string; name: string; id: number | null },
									index: number,
								) => <CarrierChip key={`spare-${index}`} carrier={spare} />,
							)}
					</div>
				);
			},
			minWidth: 20,
			flex: 3,
		},
		{
			field: "Comments",
			headerName: "Comments",
			cellRenderer: (params: any) => {
				return CommentsColumn({ carrier: params?.data as SpareCarrier });
			},
			minWidth: 20,
			flex: 1,
		},
	];
	return { columnDefsLeft };
};

export const useTableDataRight = () => {
	const columnDefsRight: ColDef[] = [
		{
			field: "StandName",
			headerName: "Stand",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "ActionRequired",
			headerName: "Action Req.",
			wrapHeaderText: true,
			autoHeaderHeight: true,
			flex: 1,
			valueGetter: (params) =>
				actionRequiredCodes.find(
					(code) => code.Code === (params.data as any).ActionRequired,
				)?.Name,
			cellRenderer: ActionRequiredTag,
			cellRendererParams: (params: ICellRendererParams) => ({
				status: actionRequiredCodes.find(
					(code) => code.Code === (params.data as any).ActionRequired,
				),
			}),
		},
		{
			field: "CarrierSpares",
			headerName: "Carriers - Spares",
			cellRenderer: (params: ICellRendererParams) => {
				const carriers = (params.data as SpareCarrier)?.SparesFormatted || [];

				return (
					<div style={{ display: "flex", gap: "4px", flexWrap: "wrap" }}>
						{carriers.length > 0 &&
							carriers.map(
								(
									spare: { status: string; name: string; id: number | null },
									index: number,
								) => <CarrierChip key={`spare-${index}`} carrier={spare} />,
							)}
					</div>
				);
			},
			minWidth: 20,
			flex: 3,
		},
		{
			field: "Comments",
			headerName: "Comments",
			cellRenderer: (params: any) => {
				return CommentsColumn({ carrier: params?.data as SpareCarrier });
			},
			minWidth: 20,
			flex: 1,
		},
	];
	return { columnDefsRight };
};
